import React, { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { apiURL } from "../../../utils/constant";
import { getApiData } from "../../selector/auth.selector";
import { useDispatch, useSelector } from "react-redux";
import { get, size } from "lodash";
import { setVisitsData } from "../../reducer/visits.reducer";
import { hidePageLoader, showPageLoader } from "../../reducer/pageLoader.reducer";

const useVisitDetails = () => {
  const [visits, setVisits] = useState();
  const dispatch = useDispatch();
  const loginData = useSelector(getApiData);
  const subjectId = get(loginData, "SubjectId", "");
  const fetchVisitDetails = useCallback(async () => {
    try {
      dispatch(showPageLoader())
      const { data } = await Api.get({
        url: apiURL.visitDetailsBySubjectId(),
        params: {
          SubjectId: subjectId,
        },
      });
      if (size(data) <= 0) {
        alert("No data found");
      } else {
        dispatch(setVisitsData(data));
        dispatch(hidePageLoader())
      }
      // setVisits(data);
    } catch (error) {
      dispatch(hidePageLoader())
      console.log("err==>", error);
    }
  }, [subjectId]);
  return {
    visits,
    fetchVisitDetails,
  };
};

export default useVisitDetails;
